import React, { useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FormInput } from "go-form";
import { useWindowSize } from "go-core/components/useWindowSize";
import { ReactComponent as DropdownSVG } from "go-core/images/svg/dropdown.svg";
import FormNumberInput from "go-form/components/FormNumberInput";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { OrderShipApi, ProductStateApi } from "../../../../../../../../../../services/Api/Organization/types";
import { isItemRowIndexShown, showMore } from "../../../../utils/itemsTableUtils";
import { drawProductState, getStateForProduct } from "../../../../utils/productStateUtils";

interface Props {
	form: UseFormReturn<OrderShipApi>;
	productStates: ProductStateApi[];
}

const OrderShipItemsTableForm = ({ form, productStates }: Props) => {
	const {
		watch,
		formState: { errors },
		control,
		register,
	} = form;
	const { t } = useTranslation();
	const isMobile = useWindowSize().isMobile;
	const watchedItems = watch("items");
	const [shownIndexes, setShownIndexes] = useState<number[]>([]);
	const organization = useSelector(selectOrganization);

	return (
		<fieldset className="form-group">
			<div className={`${isMobile ? "table-responsive" : ""}`}>
				<table
					className={`table table-form positions-table order-ship-items-table ${
						isMobile ? "vertical-top" : ""
					}`}
				>
					<thead>
						<tr>
							<th className="action" />
							<th>{t("common.word.product")}</th>
							<th>{t("modules.order.field.ordered_quantity.title")}</th>
							<th>{t("modules.order.field.quantity_shipped.title")}</th>
							<th>{t("modules.order.field.quantity_to_shipped.title")}</th>
						</tr>
					</thead>
					<tbody>
						{watchedItems.map((item, index) => {
							return (
								<React.Fragment key={index}>
									<tr>
										<td className="action" />
										<td>
											<div className="d-flex align-items-center product-box">
												<DropdownSVG
													className="icon"
													id={`icon-${index}`}
													style={{
														transform: isItemRowIndexShown(shownIndexes, index)
															? "rotate(180deg)"
															: "unset",
													}}
													onClick={() => showMore(shownIndexes, setShownIndexes, index)}
												/>
												<Link
													rel="noreferrer"
													target="_blank"
													to={`/${organization.id}/products/${item.product.id}/edit`}
													className="ms-2"
												>
													{item.product.name}
												</Link>
											</div>
										</td>
										<td>{item.quantity.toFixed(5)}</td>
										<td>{item.quantity_shipped.toFixed(5)}</td>
										<td>
											<FormNumberInput
												errors={errors}
												name={`items.${index}.quantity_to_ship`}
												control={control}
												suffix=""
												allowNegative={false}
												decimalScale={5}
											/>
										</td>
									</tr>
									{isItemRowIndexShown(shownIndexes, index) && (
										<tr>
											<td className="action" />
											<td>
												<div className="d-flex flex-column">
													<FormInput
														errors={errors}
														register={register}
														className="comment-input"
														name={`items.${index}.comment`}
														placeholder={t("common.word.comment.placeholder")}
													/>
													{getStateForProduct(item?.product, productStates) && (
														<small className="text-muted font-weight-bold mt-2">
															{drawProductState(item?.product, productStates, t)}
														</small>
													)}
												</div>
											</td>
											<td />
											<td />
											<td />
										</tr>
									)}
								</React.Fragment>
							);
						})}
					</tbody>
				</table>
			</div>
		</fieldset>
	);
};

export default OrderShipItemsTableForm;
